
import React from 'react';
import { motion } from 'framer-motion';

export default function OrganiShape({ className, color = 'mint', opacity = 0.3, delay = 0 }) {
  const colorMap = {
    mint: 'hsl(160 70% 50%)',
    coral: 'hsl(16 100% 50%)',
    sky: 'hsl(200 80% 60%)',
    sand: 'hsl(40 60% 75%)'
  };

  return (
    <motion.div
      className={`absolute pointer-events-none blur-[60px] rounded-full mix-blend-multiply ${className}`}
      style={{
        backgroundColor: colorMap[color],
        opacity: opacity,
      }}
      animate={{
        scale: [1, 1.1, 0.9, 1],
        rotate: [0, 90, 180, 360],
        borderRadius: ["60% 40% 30% 70%/60% 30% 70% 40%", "30% 70% 70% 30%/30% 30% 70% 70%", "60% 40% 30% 70%/60% 30% 70% 40%"]
      }}
      transition={{
        duration: 20,
        repeat: Infinity,
        repeatType: "reverse",
        ease: "easeInOut",
        delay: delay
      }}
    />
  );
}
